// extracted by mini-css-extract-plugin
export default {"AssetAmountFilter":"index__AssetAmountFilter__Y0JWH","AssetsList":"index__AssetsList__CMKBA"};